import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService, IdmApiService } from '../../../../../services/index';
import { BoltMaterialModel } from '../../../models/index';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-bolt-material',
    templateUrl: './bolt-material.component.html',
    styleUrls: ['./bolt-material.component.scss'],
    standalone: false
})
export class BoltMaterialComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set standardId(value: string) {
        if (value) {
            this._standardId = value;
            this.cd.detectChanges();
            if (!this.jointCalcService.isPipeCode) {
                this.getBoltMaterials();
            }
        }
    }
    get standardId(): string {
        return this._standardId;
    }

    @Input()
    set isCustom(value: boolean) {
        if (value) {
            this._isCustom = value;
            if (!this.jointCalcService.isPipeCode) this.getBoltMaterials();
        }
    }
    get isCustom(): boolean {
        return this._isCustom;
    }

    @Input()
    set isGetAllBoltMaterials(value: boolean) {
        this._isGetAllBoltMaterials = value;
        if (value) if (!this.jointCalcService.isPipeCode) this.getBoltMaterials();
    }
    get isGetAllBoltMaterials(): boolean {
        return this._isGetAllBoltMaterials;
    }

    @Input()
    set doBoltMaterialReset(value: boolean) {
        if (value) {
            this.selectedValue = '';
        }
    }
    @Output() selected: EventEmitter<BoltMaterialModel> = new EventEmitter();
    @ViewChild(MatPaginator) paginator: MatPaginator;
    destroy$ = new Subject();

    tooltip_position = 'above';

    selectedRow: BoltMaterialModel;
    selectedId: string;
    selectedValue: string;
    public filterlist: BoltMaterialModel[];
    public pageSize = 5;
    public currentPage = 0;
    public totalSize = 0;
    public searchFilterList: BoltMaterialModel[];
    searchText = new UntypedFormControl('', []);
    closeResult: string;
    displayedColumns: string[] = [];
    optionList: MatTableDataSource<BoltMaterialModel> | BoltMaterialModel[];
    optionListCopy: BoltMaterialModel[];
    filterData: string;

    private boltMaterialModalRef: NgbModalRef;
    private _standardId: string;
    private _isCustom: boolean = false;
    private _isGetAllBoltMaterials: boolean = false;
    constructor(
        private iceapi: IceapiService,
        private modalService: NgbModal,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private router: Router,
        private jointCalcService: JointCalcService,
        private cd: ChangeDetectorRef,
        private idmApi: IdmApiService
    ) {}

    ngOnInit(): void {
        this.updateDisplayedColumns();
        this.form.markAllAsTouched();
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithBoltMaterial();
        }

        this.form
            .get('boltMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value)
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                        this.jointCalcService.selectedboltMaterial.next(value);
                    }
            });
    }

    updateDisplayedColumns(): void {
        if (this.router.url === '/idms/plantmanager') {
            this.displayedColumns = ['id', 'alias', 'position', 'type', 'design', 'composition', 'class'];
        } else {
            this.displayedColumns = ['id', 'position', 'type', 'design', 'composition', 'class'];
        }
    }

    async getBoltMaterials() {
        this.form.markAllAsTouched();
        if (this.isGetAllBoltMaterials || this.standardId !== undefined || this.isCustom) {
            let boltMaterials = await this.apiCallLoadBoltMaterial();
            if (boltMaterials.success === true) {
                this.optionListCopy = boltMaterials.response;
                this.filterlist = boltMaterials.response;
                this.optionList = new MatTableDataSource(boltMaterials.response);
                this.optionList.paginator = this.paginator;
                this.totalSize = this.filterlist.length;
                if (this.filterData) {
                    this.iterator(this.searchFilterList);
                } else {
                    this.iterator(this.filterlist);
                }
                this.selectedValue = boltMaterials.response.find((x) => x.boltMaterialId == this.form.get('boltMaterial')?.value)?.qualifiedName;
                this.dataService.selectedBoltMaterialObject = boltMaterials.response.find((x) => x.boltMaterialId == this.form.get('boltMaterial')?.value);

                if (this.dataService.selectedBoltMaterialObject && this.dataService.selectedBoltMaterialObject?.alias?.materialAliasId) {
                    this.dataService.boltMaterialAliasId = this.dataService.selectedBoltMaterialObject?.alias?.materialAliasId;
                    this.form.get('boltMaterialAliasId')?.setValue(this.dataService.selectedBoltMaterialObject?.alias?.materialAliasId);
                }
                //If there is only one row.
                if (this.optionListCopy.length === 1) {
                    this.selectedValue = `${this.optionListCopy[0].qualifiedName}`;
                    this.form.get('boltMaterial').setValue(this.optionListCopy[0].boltMaterialId);
                }
            } else {
                this.user_utility.errorModelPopup(boltMaterials.message);
            }
        }
    }

    async apiCallLoadBoltMaterial() {
        if (this.router.url != '/idms/plantmanager') {
            return await this.iceapi.getBoltMaterials(this.standardId, this.isCustom).toPromise();
        } else {
            return await this.idmApi.getCalcBoltMaterials(this.standardId, this.isCustom).toPromise();
        }
    }

    public handlePage(e: any) {
        this.currentPage = e.pageIndex;
        this.pageSize = e.pageSize;
        if (this.filterData) {
            this.iterator(this.searchFilterList);
        } else {
            this.iterator(this.filterlist);
        }
    }

    private iterator(array: any) {
        const end = (this.currentPage + 1) * this.pageSize;
        const start = this.currentPage * this.pageSize;
        const part = array.slice(start, end);
        this.optionList = part;
    }

    applyFilter($event: any) {
        this.filterData = $event.target.value;

        this.searchFilterList = [];
        this.searchFilterList = this.optionListCopy.filter((item) => {
            return (
                (item.boltMaterialSpecNo.specNo !== undefined ? item.boltMaterialSpecNo.specNo : '')
                    .toLowerCase()
                    .trim()
                    .includes(this.filterData.toLowerCase().trim()) ||
                (item.typeGrade !== undefined ? item.typeGrade : '').toLowerCase().trim().includes(this.filterData.toLowerCase().trim()) ||
                (item.alloyDesignUnsno !== undefined ? item.alloyDesignUnsno : '').toLowerCase().trim().includes(this.filterData.toLowerCase().trim()) ||
                (item.nominalComposition !== undefined ? item.nominalComposition : '').toLowerCase().trim().includes(this.filterData.toLowerCase().trim()) ||
                (item.classCondTemp !== undefined ? item.classCondTemp : '').toLowerCase().trim().includes(this.filterData.toLowerCase().trim())
            );
        });
        this.currentPage = 0;
        this.totalSize = this.searchFilterList.length;
        this.iterator(this.searchFilterList);
        if ($event.key === 'Backspace') {
            this.optionListCopy = this.filterlist;
            this.searchFilterList = [];
        }
    }

    open(content) {
        this.searchText.reset('');
        this.optionList = new MatTableDataSource(this.filterlist);
        this.optionList.paginator = this.paginator;
        this.totalSize = this.filterlist.length;
        this.currentPage = 0;
        this.iterator(this.filterlist);

        this.boltMaterialModalRef = this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            keyboard: false,
            size: 'xl',
        });
        this.boltMaterialModalRef.result.then(
            (result) => {
                this.searchText.reset('');
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    selectItem(row: BoltMaterialModel) {
        this.selectedRow = row;
        this.selectedId = row.boltMaterialId;
        this.selectedValue = `${row.qualifiedName}`;
        this.form.get('boltMaterial').setValue(row.boltMaterialId);
        // this.modalService.dismissAll()
        if (this.boltMaterialModalRef) {
            this.boltMaterialModalRef.close();
        }
        this.selected.emit(this.selectedRow);
        this.dataService.selectedBoltMaterial = this.selectedRow.qualifiedName;
        this.dataService.selectedBoltMaterialObject = row;
        if (row?.alias?.materialAliasId) {
            this.dataService.boltMaterialAliasId = row.alias.materialAliasId;
            this.form.get('boltMaterialAliasId')?.setValue(row?.alias?.materialAliasId);
        }
        this.form.markAllAsTouched();
    }

    private reset(): void {
        this.selectedRow = null;
        this.selectedId = null;
        this.selectedValue = null;
    }

    async pipespecwithBoltMaterial() {
        this.jointCalcService.selectedBoltType.pipe(takeUntil(this.destroy$)).subscribe(async (bt) => {
            const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
            if (bt && inputGroup.calculationType == CalculationType.StandardFlange) {
                if (bt == 'Metric') {
                    inputGroup.others.boltType = 0;
                } else if (bt == 'Imperial') {
                    inputGroup.others.boltType = 1;
                }
                inputGroup.others.tighteningSpecification = null;
                await this.pipeSpecmanageApiCall();
            }
        });

        this.jointCalcService.selectedpipeSize.pipe(takeUntil(this.destroy$)).subscribe(async (pz) => {
            if (pz) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                inputGroup.recordId.clampMaterialId =
                    inputGroup.recordId.pipeScheduleId =
                    inputGroup.recordId.hubMaterialId =
                    inputGroup.recordId.sealRingMaterialId =
                    inputGroup.recordId.sealRingId =
                    inputGroup.others.boltType =
                        null;

                inputGroup.recordId.pipeSizeId = pz;
                if (this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.Clamp) {
                    await this.pipeSpecmanageApiCall();
                }
            }
        });
    }

    async pipeSpecmanageApiCall() {
        let pipeSpecBoltMaterial = await this.idmApi
            .getCalcBoltMaterials(this.jointCalcService.pipeSpecpayload.lookupParams.recordId.standardId, this.isCustom)
            .toPromise();

        if (pipeSpecBoltMaterial.success) {
            this.optionListCopy = pipeSpecBoltMaterial.response;
            this.optionListCopy = await this.jointCalcService.managePayloadForRecourdId('boltMaterialId', pipeSpecBoltMaterial.response);
            this.filterlist = this.optionListCopy.slice();
            this.optionList = new MatTableDataSource(this.optionListCopy.slice());
            this.optionList.paginator = this.paginator;
            this.totalSize = this.filterlist.length;
            if (this.filterData) {
                this.iterator(this.searchFilterList);
            } else {
                this.iterator(this.filterlist);
            }
            this.selectedValue = this.optionListCopy.slice().find((x) => x.boltMaterialId == this.form.get('boltMaterial').value)?.qualifiedName;
            this.dataService.selectedBoltMaterialObject = this.optionListCopy.slice().find((x) => x.boltMaterialId == this.form.get('boltMaterial').value);
            //If there is only one row.
            if (this.optionListCopy.length === 1) {
                this.selectedValue = `${this.optionListCopy[0].qualifiedName}`;
                this.form.get('boltMaterial').setValue(this.optionListCopy[0].boltMaterialId);
            } else if (this.dataService.calculationData?.input?.recordId?.boltMaterialId) {
                this.form.get('boltMaterial').setValue(this.dataService.calculationData?.input?.recordId?.boltMaterialId);
                this.selectedValue = this.optionListCopy.slice().find((x) => x.boltMaterialId == this.form.get('boltMaterial').value)?.qualifiedName;
            }
        } else if (pipeSpecBoltMaterial.isCustom) {
            this.user_utility.errorModelPopup(pipeSpecBoltMaterial.message);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
